import eventBus from '@sd-utility/eventbus';
import { PLPQueryData, usePLPQuery } from 'client/api/plp-results';
import { PLP_GRID_UPDATE_EVENT, PLP_RESULTS_UPDATE_EVENT } from 'client/config';
import useGlobalConfig from 'client/state/GlobalConfig';
import { useMainState } from 'client/state/Main';
import { updateDataLayer } from 'common/dataTracking/data-layer';
import { useCallback, useEffect, useRef } from 'react';

export const useResultUpdateEvent = () => {
  const { brand } = useGlobalConfig();
  const plpurl = useMainState((s) => s.plpURL);
  const { data } = usePLPQuery(
    useCallback((d: PLPQueryData) => d.rawResponse, []),
    (oldData, newData) => (oldData?.meta.result_id !== newData.meta.result_id ? newData : oldData ?? newData),
  );
  const initRender = useRef(true);

  useEffect(() => {
    if (initRender.current) {
      initRender.current = false;
      return;
    }
    if (!data) return;
    eventBus.publish(PLP_RESULTS_UPDATE_EVENT, { response: data, path: plpurl.href, brand });
  }, [brand, data, plpurl]);
};

export const useDataLayerEvent = () => {
  const { pageType } = useGlobalConfig();
  // eslint-disable-next-line no-unused-vars
  const { data } = usePLPQuery(useCallback(({ rawResponse, ...d }: PLPQueryData) => d, []));
  const initRender = useRef(true);

  useEffect(() => {
    if (initRender.current) {
      initRender.current = false;
      return;
    }
    if (!data) return;
    updateDataLayer(data, pageType);
  }, [data, pageType]);
};

export const useGridUpdateEvent = () => {
  const { pageType } = useGlobalConfig();
  // eslint-disable-next-line no-unused-vars
  const { data, isFetching } = usePLPQuery(useCallback(({ rawResponse, ...d }: PLPQueryData) => d, []));
  const lastAction = useMainState((s) => s.lastAction);

  const initRender = useRef(true);

  return useEffect(() => {
    const isInitRender = initRender.current;
    if (isInitRender) initRender.current = false;
    if (isFetching) return;
    if (!isInitRender) updateDataLayer(data, pageType);

    const isSelectedFacet = !!Object.keys(data?.selectedFacets ?? {}).length;
    eventBus.publish(PLP_GRID_UPDATE_EVENT, {
      pageType,
      eventTrigger: lastAction,
      isSelectedFacet,
    });
  });
};
